
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M15 6.81v7.05A1.14 1.14 0 0113.84 15H2.14A1.14 1.14 0 011 13.86v-7a1.2 1.2 0 01-1-1.39l.73-3.55A1.14 1.14 0 011.85 1h12.29a1.14 1.14 0 011.12.92L16 5.46a1.21 1.21 0 01-1 1.35zm-12.8 0v6.72a.28.28 0 00.28.28h11.04a.28.28 0 00.28-.28v-6.7h-2.32a1.11 1.11 0 01-.87-.4L8.22 3.59a.3.3 0 00-.41 0L5.39 6.43a1.15 1.15 0 01-.87.4zM8 9.17a1.14 1.14 0 011.14 1.14v3.52H6.86v-3.52A1.14 1.14 0 018 9.17zm-4.28 0h1.71a.29.29 0 01.29.28v1.76a.29.29 0 01-.29.29H3.72a.29.29 0 01-.29-.29V9.45a.29.29 0 01.29-.28zm6.85 0h1.72a.29.29 0 01.28.28v1.76a.29.29 0 01-.28.29h-1.72a.28.28 0 01-.28-.29V9.45a.28.28 0 01.28-.28z"}})])
          )
        }
      }
    